import React from 'react'
import dayjs from 'dayjs'
import { TimeToJumpAbsoluteTimeStyled, TimeToJumpDayFlagStyled } from './TimeToJump.style'
import { RaceCountdown } from '@core/Components/RaceCountdown'

export const TimeToJumpComponent: React.FC<{
  size?: string
  showDay: boolean
  showCountDown: boolean
  advertisedStartTime: Date
  showDayBeforeTime?: boolean
}> = ({ showDay, showCountDown, advertisedStartTime, size, showDayBeforeTime = false }) => {
  if (showCountDown) return <RaceCountdown raceStartTime={advertisedStartTime} displaySize={size} />

  return (
    <TimeToJumpAbsoluteTimeStyled size={size || '1.2rem'} data-testid='time-ast'>
      {showDay && showDayBeforeTime && (
        <TimeToJumpDayFlagStyled size={size}>
          {dayjs(advertisedStartTime).format('ddd')}
        </TimeToJumpDayFlagStyled>
      )}

      <div>{dayjs(advertisedStartTime).format('HH:mm')}</div>

      {showDay && !showDayBeforeTime && (
        <TimeToJumpDayFlagStyled size={size}>
          {dayjs(advertisedStartTime).format('ddd')}
        </TimeToJumpDayFlagStyled>
      )}
    </TimeToJumpAbsoluteTimeStyled>
  )
}
